// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3jC9H","header":"ClearentDisclaimer_header__37H5T","inner":"ClearentDisclaimer_inner__1ilyF"};